omadapp.singletons.preloader = new(function() {
    var t = this;
    var $ = jQuery
    t.cargarConjunto = cargarConjunto
    var app = omadapp.App
    var $b = $("body")

    function cargarConjunto (array,callbackComplete,callbackProgress) {
        trace ("preloader::cargarConjunto ("+array.length+")")
    	if (array.length==0&&callbackComplete) {
    		callbackComplete()
    		return
    	}
    	var xx = new Cargador(array,callbackComplete,callbackProgress)
    	return xx
    }

    function Cargador (array,callbackComplete,callbackProgress) {
    	var t = this;
    	var cargadas = []
    	function inicializar() {
    		trace ("Cargador::inicializar")
            for (var i = array.length - 1; i >= 0; i--) {
                if ($(array[i]).attr("src") == "") {
                    array.splice(i,1)
                }
            }
    		for (var i = 0; i < array.length; i++) {
    			var newImg =  array[i]
    			if (newImg.complete) {
                    setTimeout(function() {
    				    comprobarImagenes(newImg)
                    },50)
    			} else {
					newImg.onload = function() {
					    comprobarImagenes(newImg)
					}

    			}
				
    			
    		}

    	}

    	function comprobarImagenes(img) {
            trace ("preloader::comprobarImagenes")
            trace (img.width)
    		cargadas.push(img.src)
    		if (callbackProgress) {
    			callbackProgress(cargadas.length/array.length)
    		}
            trace (cargadas.length+"   "+array.length)
    		if (cargadas.length==array.length&&callbackComplete) {
    			callbackComplete()
    		}
    	}
    	inicializar()
    }


})

